import { isArray } from 'lodash';
import { arrayOf } from 'prop-types';
import React from 'react';
import { GoBug, GoRadioTower, GoTools } from 'react-icons/go';
import Moment from 'react-moment';
import {
  Button,
  List,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import { announcementShape } from '../../prop-types';
import { COLORS } from '../../utils/constants';
import { getItem } from '../../utils/local-storage';
import { BUG, GENERAL, MAINTENANCE, OUTAGE_TIME_FORMAT } from './constants';
import getUpcomingAnnouncements from './get-upcoming-announcements';
import {
  isAnnouncementViewed,
  markAnnouncementAsViewed,
} from './outage-persistence-utils';

const MINUTE = 60 * 1000;

class NotificationModal extends React.Component {
  /* eslint-disable no-use-before-define */
  state = NotificationModal.getDerivedStateFromProps(this.props);

  static getDerivedStateFromProps({ announcements }) {
    const upcomingAnnouncements = getUpcomingAnnouncements(
      announcements,
      120 * MINUTE,
    );
    return {
      upcomingAnnouncements,
      isOpen: upcomingAnnouncements
        ? !isAnnouncementViewed(upcomingAnnouncements)
        : false,
    };
  }

  handleOkClick = () => {
    markAnnouncementAsViewed(this.state.upcomingAnnouncements);
    this.setState({ isOpen: false });
  };

  render() {
    const { upcomingAnnouncements, isOpen } = this.state;

    if (!upcomingAnnouncements) {
      return null;
    }
    const log = JSON.parse(getItem('ANNOUNCEMENTS_LOG')) || [];
    const isLogArray = isArray(log);
    const viewedAnnouncementIds = isLogArray ? log : [];

    const unviewedAnnouncements = upcomingAnnouncements.filter(
      announcement => !viewedAnnouncementIds.includes(announcement.id),
    );

    const outageNotifications = unviewedAnnouncements.filter(notification =>
      notification.type.includes(MAINTENANCE),
    );
    const generalNotifications = unviewedAnnouncements.filter(notification =>
      notification.type.includes(GENERAL),
    );
    const bugNotifications = unviewedAnnouncements.filter(notification =>
      notification.type.includes(BUG),
    );

    const header = notificationType => (
      <ModalHeader className={notificationType === BUG ? 'font-color-red' : ''}>
        {notificationType === MAINTENANCE && (
          <GoTools className="mr-2 h15 mb-0" />
        )}
        {notificationType === GENERAL && (
          <GoRadioTower className="mr-2 h15 mb-0" />
        )}
        {notificationType === BUG && <GoBug className="mr-2 h15 mb-0" />}
        {notificationType}
      </ModalHeader>
    );

    const transformNotifications = notifications =>
      notifications.map(announcement => {
        const { start, end, message, type, id } = announcement;

        return (
          <div key={id}>
            {type === MAINTENANCE ? (
              <div>
                <br />
                Heads up! Sales Cockpit will be down for maintenance/upgrades
                today from{' '}
                <span className="font-weight-bold">
                  <Moment format="hh.mma">{start}</Moment>
                </span>{' '}
                to{' '}
                <span className="font-weight-bold">
                  <Moment format={OUTAGE_TIME_FORMAT}>{end}</Moment>
                </span>
                . Please plan your work accordingly.
                <br />
                <br />
                We will send another reminder about 15 minutes before the outage
                is about to begin.
              </div>
            ) : (
              <>
                <br />
                <li key={id}>{message}</li>
              </>
            )}
          </div>
        );
      });

    return (
      <Modal isOpen={isOpen}>
        {outageNotifications.length > 0 && (
          <>
            {header(MAINTENANCE)}
            <ModalBody>{transformNotifications(outageNotifications)}</ModalBody>
          </>
        )}
        {generalNotifications.length > 0 && (
          <>
            {header(GENERAL)}
            <ModalBody>
              <List>{transformNotifications(generalNotifications)}</List>
            </ModalBody>
          </>
        )}
        {bugNotifications.length > 0 && (
          <>
            {header(BUG)}
            <ModalBody>
              <List>{transformNotifications(bugNotifications)}</List>
            </ModalBody>
          </>
        )}
        <ModalFooter>
          <Button color={COLORS.PRIMARY} onClick={this.handleOkClick}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

NotificationModal.propTypes = {
  announcements: arrayOf(announcementShape.isRequired).isRequired,
};

export default NotificationModal;
